/* eslint-disable  react/prop-types */

import React from 'react';

const DuoCheckIconGreen = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="duo-check-icon-green"
  >
    <rect width="64" height="64" fill="#E5E5E5" />
    <g clipPath="url(#clip0_1099_59933)">
      <rect width="1440" height="1701" transform="translate(-711 -298)" fill="#F4F8FA" />
      <path d="M-711 -184H729V70C729 109.764 696.765 142 657 142H-711V-184Z" fill="white" />
      <g filter="url(#filter0_d_1099_59933)">
        <rect x="-318" y="20" width="654" height="80" rx="8" fill="#00AED9" />
      </g>
      <g opacity="0.6">
        <rect x="-711" y="-298" width="1440" height="1701" fill="#122946" />
      </g>
      <g filter="url(#filter1_d_1099_59933)">
        <rect x="-324" y="-100" width="706" height="432" rx="3" fill="white" />
      </g>
      <circle cx="32" cy="32" r="31" stroke="#237032" strokeWidth="2" />
      <path
        d="M20.0469 35.6125C23.093 38.8432 27.8469 43.8852 27.8469 43.8852L46.0469 22.2186"
        stroke="#237032"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1099_59933)">
      <rect width="1440" height="1701" transform="translate(-711 -298)" fill="#F4F8FA" />
      <path d="M-711 -184H729V70C729 109.764 696.765 142 657 142H-711V-184Z" fill="white" />
      <g filter="url(#filter2_d_1099_59933)">
        <rect x="-318" y="20" width="654" height="80" rx="8" fill="#00AED9" />
      </g>
      <g opacity="0.6">
        <rect x="-711" y="-298" width="1440" height="1701" fill="#122946" />
      </g>
      <g filter="url(#filter3_d_1099_59933)">
        <rect x="-324" y="-100" width="706" height="432" rx="3" fill="white" />
      </g>
      <circle cx="32" cy="32" r="31" stroke="#237032" strokeWidth="2" />
      <path
        d="M20.0469 35.6125C23.093 38.8432 27.8469 43.8852 27.8469 43.8852L46.0469 22.2186"
        stroke="#237032"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1099_59933"
        x="-321"
        y="19"
        width="660"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <filter
        id="filter1_d_1099_59933"
        x="-327"
        y="-101"
        width="712"
        height="438"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <filter
        id="filter2_d_1099_59933"
        x="-321"
        y="19"
        width="660"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <filter
        id="filter3_d_1099_59933"
        x="-327"
        y="-101"
        width="712"
        height="438"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0941176 0 0 0 0 0.207843 0 0 0 0 0.345098 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1099_59933" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1099_59933" result="shape" />
      </filter>
      <clipPath id="clip0_1099_59933">
        <rect width="1440" height="1701" fill="white" transform="translate(-711 -298)" />
      </clipPath>
      <clipPath id="clip1_1099_59933">
        <rect width="1440" height="1701" fill="white" transform="translate(-711 -298)" />
      </clipPath>
    </defs>
  </svg>
);

export default DuoCheckIconGreen;
